// Cart counter — badge .count na a.cart-count, re-bind na ShoptetCartUpdated.
// Offline (bez window.shoptet) jen naváže listener a no-opuje; aktivní na ostrém webu.
import { onCartUpdated, cartState } from '../shoptet-hooks.js';
import { page } from './pages.js';
import L from '../locale/cs/cartCounter.js';

const LABEL_EYEBROW = L.eyebrow;
const LABEL_EMPTY = L.empty;

function readCount(cart) {
  if (!cart) return 0;
  if (cart.itemsCount != null) return Number(cart.itemsCount) || 0;
  if (cart.count != null) return Number(cart.count) || 0;
  return 0;
}

export function initCartCounter() {
  const trigger = document.querySelector('a.cart-count');
  if (!trigger || trigger.dataset.bsCounter) return;
  trigger.dataset.bsCounter = '1';

  // Klik/tap = VŽDY navigace do košíku. Default JS je toggle-window nad
  // mini-cart popupem, který skrýváme (feedback řeší cartToast) — na touch
  // zařízeních tap odchytil a „nic se nestalo". touchend capture předběhne
  // delegovaný default handler i syntetický click.
  // touchend targetuje element, kde gesto ZAČALO → scroll započatý prstem na
  // košíku by bez rozlišení tap/scroll nechtěně navigoval do košíku
  let touchMoved = false;
  trigger.addEventListener('touchstart', function () { touchMoved = false; }, { passive: true, capture: true });
  trigger.addEventListener('touchmove', function () { touchMoved = true; }, { passive: true, capture: true });
  const goToCart = function (e) {
    if (e.type === 'touchend' && touchMoved) return; // scroll gesto, ne tap
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.assign(trigger.getAttribute('href') || page('cart'));
  };
  trigger.addEventListener('click', goToCart, true);
  trigger.addEventListener('touchend', goToCart, true);

  // Dvouřádkový text („Košík" + cena | „Prázdný") — design blok, klidně smaž.
  // Nativní .cart-price přesouváme do labelu (default JS ji dál aktualizuje),
  // stav prázdný/plný přepíná třída has-items.
  if (!trigger.querySelector('.bs-cart-text')) {
    const text = document.createElement('span');
    text.className = 'bs-cart-text';
    text.innerHTML =
      '<span class="bs-cart-text__eyebrow">' + LABEL_EYEBROW + '</span>' +
      '<span class="bs-cart-text__label"><span class="bs-cart-empty">' + LABEL_EMPTY + '</span></span>';
    const label = text.querySelector('.bs-cart-text__label');
    const price = trigger.querySelector('.cart-price');
    if (price) label.appendChild(price);
    trigger.appendChild(text);
  }

  function render(cart) {
    const count = readCount(cart);
    trigger.classList.toggle('has-items', count > 0);
    let badge = trigger.querySelector('.count');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'count';
        trigger.appendChild(badge);
      }
      badge.textContent = String(count);
    } else if (badge) {
      badge.remove();
    }
  }

  onCartUpdated(render);
  render(cartState());
}
